import type { ICellRendererParams } from 'ag-grid-community'
import { Horizontal, Vertical, Texto, MaterialIcon } from '@gravitate-js/excalibrr'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'
import { useNavigate } from 'react-router-dom'

const OrderNumberWithLink = ({ orderNumber }: { orderNumber: string }) => {
  const navigate = useNavigate()
  return (
    <span
      style={{
        color: 'var(--theme-color-2)',
        cursor: 'pointer',
        textDecoration: 'underline',
      }}
      onClick={() => {
        navigate(`/order_movements_page/report?order_number=${orderNumber}`)
      }}
    >
      {orderNumber}
    </span>
  )
}

export function OrderNumbersCellRenderer({ data }: ICellRendererParams<Match>) {
  const orderNumbers = data?.order_numbers || []

  if (!orderNumbers.length)
    return (
      <Horizontal verticalCenter style={{ overflow: 'visible' }} gap={4}>
        <MaterialIcon style={{ color: 'var(--theme-error)' }} icon='warning' />
        <Texto appearance='hint'>N/A</Texto>
      </Horizontal>
    )

  return (
    <Vertical justifyContent='center' style={{ gap: '4px', overflow: 'visible' }}>
      {orderNumbers.map((order, index) => (
        <OrderNumberWithLink key={order.id || `${order.number}-${index}`} orderNumber={order.number} />
      ))}
    </Vertical>
  )
}
